<template>

    <div class="full-height ">

      <v-data-table
          :headers="headers"
          :items="items"
          dense
          :hide-default-footer="true"
          :disable-pagination="true"
          no-data-text="No Messages"
          :show-expand="false"
          :item-class="row_classes"
          :fixed-header="true"
          class="filter-table full-height"
          width="100%"
          :key="`filter_list_${refresh}`"
          :disable-sort="true"
          :loading="getGroupPageLoading"
          id="groupPageMessagesList"
          item-key="_id"


      >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-0 ma-0 fs-10 pl-5 font-weight-light">
        <div v-if="isRowExpanded(item)">
          <!-- Show details here -->
          <div v-for="historyItem in item.history" :key="historyItem.id">
            {{ historyItem.details }}
          </div>
        </div>
        <div v-else>No history available</div>
      </td>
    </template>
              
        <template v-slot:header.select="{ item }">
            <v-tooltip bottom
              v-if="items && items.length"
              nudge-bottom="0"
              nudge-right="40"
              color="ycmd-black"
              :disabled="$vuetify.breakpoint.xsOnly"
              content-class="fade-0 ">
              <template v-slot:activator="{ on }">
                  <v-btn icon rounded
                      @click="selectAll()"
                      v-on="on"
                      >
                      <v-icon :size="22" color="">{{headerSelectIcon}}</v-icon>
                  </v-btn>
              </template>
              <span>Select all</span>
          </v-tooltip>
        </template>
        
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              :class="`text-${header.align ? header.align : 'left'} ${cellClass(header, item)}`"
              @click="cellClick(header,item)"
            >
              

            <v-tooltip 
              v-if="header.value === 'select'"
                        bottom
                        nudge-bottom="5"
                        color="ycmd-black"
                        content-class="fade-0">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="ycmd-blue"
                  class="pointer"
                  :size="22"
                >
                  {{item.selected ? 'check_circle_outline': 'radio_button_unchecked'}}
                  
                </v-icon>
              </template>
              <span>Select</span>
            </v-tooltip>

              <template v-else-if="header.value === 'expand'">
                <v-icon 
                  v-if="item.history && item.history.length"
                  color="ycmd-blue" class="pointer" :size="22" @click="toggleExpand(item)">
                  {{item.expanded ? 'keyboard_arrow_up': 'keyboard_arrow_down'}}
                </v-icon>
              </template>


              <span v-else>
              {{item[header.value]}}
              </span>
            </td>
          </tr>
          <tr v-if="item.history && item.history.length && item.expanded">
            <td>&nbsp;</td>
            <td :colspan="headers.length-1">

  <v-simple-table
    class=""
  >
    <template v-slot:default>
      <thead
      class="ycmd-very-lightest-gray"
      >
        <tr>
          <th class="text-left ycmd-very-lightest-gray">
            Operation
          </th>
          <th class="text-left ycmd-very-lightest-gray">
            Time
          </th>
          <th class="text-left ycmd-very-lightest-gray">
            User
          </th> 
          <th class="text-left ycmd-very-lightest-gray">  
            Details
          </th>         
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="history in item.history"
          :key="history.timestamp"
          class="ycmd-very-lightest-blue"
        >
          <td>{{ formatHistoryOperation(history) }}</td>
          <td>{{ formatHistoryTimestamp(history) }}</td>
          <td>{{ formatHistoryUser(history) }}</td>
          <td>{{ formatHistoryDetails(history) }}</td>

        </tr>
      </tbody>
    </template>
  </v-simple-table>



            </td>
          </tr>

        </template>
                    

      </v-data-table>
      <phone-dialog 
        v-model="openPhone" 
        :item="phoneItem" 
        :phoneNumber="phoneNumber" 
        :fields="fields" 
        :phoneFieldId="phoneFieldId"
        @itemChanged="itemChanged"
        :canConfirm="canConfirm"
      />
    </div>



</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {formatSimple} from '@/methods/formatters';
import PhoneDialog from './phone-dialog'

import { parseJSON } from 'date-fns';

  export default {
    props: {
      fields: {
          type: Array,
          default: () => []
      },
      messages: {
        type: Array,
        default: () => []
      },
      page: {
        type: Object,
        default: () => {}
      },
      refresh: {
        default: '',
        type: String
      },  
      tab: {
        default: '',
        type: String
      },                           
              
    },
    components: {
      'phone-dialog': PhoneDialog
    },    
    data: () => ({
      filterSearch: null,
      options: {
        sortBy: ['Name'],
        sortDesc: [false]
      },
      openPhone: false,
      phoneItem: null,
      phoneNumber: '',
      phoneFieldId: '',
      expandedItems: [],
    }),
    mounted() {
      this.setScroll()
    },
    methods: {
      cellClass(header, item) {
        console.log('header', header, 'item', item)
        if (header.field && header.field.type === 'phone') {
          console.log('phone item', item)
          let key = `attribute_${header.field.id}`
          console.log('key', key)
          console.log('item[key]', item[key])

          if (item[key] === 'true') {

            return "ycmd-blue--text text-decoration-underline pointer"
          }          
        }
      },
      formatHistoryOperation(history) {
        switch (history.operation) {
          case 'confirm':
            if (history.value.value) {
              return 'Archived'
            } else {
              return 'Restored'
            }
          case 'sms':
            return 'SMS'
          default:
            return history.operation
        }
      },
      formatHistoryTimestamp(history) {
        let dt = new Date(history.timestamp)
        return formatSimple(dt,'MMM dd h:mm a')
      },
      formatHistoryUser(history) {
        return history.user_name
      },
      formatHistoryDetails(history) {
        switch (history.operation) {

          case 'sms':
            return `${history.value.status === 'SUCCESSFUL'? 'Sent SMS': 'Error Sending SMS'}: ${history.value.text}`
            
        }
      },

      itemChanged (item) {
        this.$emit('itemChanged', item)
      },



      toggleExpand (item) {
        this.$set(item, 'expanded', !item.expanded)
      },
      setScroll () {

        //let messagetable = this.$el//.querySelector(`#groupPageMessagesList`)

        let el = this.$el
        let container

        while (el) {
            if (el.classList.contains('i-card__scrollable')) {
                container = el
                break
            }

            el = el.parentElement
        }

        if (container) {
            container.addEventListener('scroll', this.localScroll, false)
        }


/*
        console.log('setscroll messagetable', messagetable)
        if (messagetable) {
            let scrollElement = messagetable.querySelector('div.v-data-table__wrapper')
            console.log('setscroll scrollElement', scrollElement)

            if (scrollElement) {
              //this.$emit('scrollElementChanged', scrollElement)
              scrollElement.addEventListener('scroll', this.localScroll, false)
            }

        }
        */
      },
      localScroll (params) {
        console.log('localScroll', params)
        this.$emit('gridScroll', params)
      },
      cellClick (header, item) {

        if (header.value === 'select') {
            this.$set(item, 'selected', !item.selected)          
        } else {
          if (header.field && header.field.type) {
              
            switch (header.field.type) {
              case 'phone':

                let key = `attribute_${header.field.id}`
                console.log('key', key)
                console.log('item[key]', item[key])

                if (item[key] === 'true') {                
                  this.phoneItem = item
                  this.phoneNumber = item[header.field.id]
                  this.phoneFieldId = header.field.id
                  //let response = await dataClient('providerPageSet', {operation: 'group_message', parameters: parameters})
                  this.openPhone = true
                }
                break

            }

          }

        }
      },
      selectAll(optionalValue) {
          let value = this.headerSelectIcon ===  'check_circle_outline' ? false: true

          if (typeof(optionalValue) !== 'undefined') {
              value = optionalValue
          }

          let length = this.items.length
          for (let i = 0;i < length; i++){
              let newItem = this.items[i]

              this.$set(newItem, 'selected',value)
              this.$set(this.items, i, newItem)
              this.expandedItems.push(newItem._id)
          }

      },
      async handleSort () {

      },
      twoDigit (num) {
        let str = num + ''
        if (str.length === 1) {
            str = '0' + str
        }
        return str
      },
      formatTime(time) {
        let pieces = time.split(':')
        let pm = false

        if (pieces[0] >= 12) {
          pieces[0] -= 12
          pm = true
        }
        return `${this.twoDigit(pieces[0])}:${this.twoDigit(pieces[1])}:${this.twoDigit(pieces[2])} ${pm ? 'PM': 'AM'}`
      },

      
      formatDate(dt) {

          let formatted = formatSimple(dt,'MM/dd/yyyy hh:mm a')
          
          return formatted
      },
      


      row_classes(item) {
        let classes = ['pa-0', 'ma-0']

        if (item.odd) {
          classes.push('odd')
        }

        return classes
      },      
    },
    computed: {
      ...mapGetters('group',['getGroupPageLoading']),
      canConfirm () {
        if (this.tab === 'tab-current') {
          return true
        } else {
          return false
        }
      },
      items () {
        console.log('items', this.messages)
        return this.messages
      },
      headers () {
        let headers = []

        let fields = JSON.parse(JSON.stringify(this.fields))

        if (fields && fields.length) {
          headers.push(            {
                  text: '',
                  value: 'expand',
                  width: '5px',
                  align: 'center',
                  sortable: false,
                  class: 'expand'
              })
        }

        if (fields && fields.length) {
          fields.push({
            id: 'Time Submitted',
            type: 'datetime',            
            size: 2
          })
        }

        let totalSize = 0
        fields.map(f => {
          let size = f.size ? parseInt(f.size+'') : 0
          if (!size) {
            size = 1
          }
          totalSize += size
        })

        fields.map(f => {
          let size = f.size ? parseInt(f.size+'') : 0
          if (!size) {
            size = 1
          }

          let header = {
            text: f.label ? f.label : f.id,
            value: f.id,
            width: `${(size / totalSize) * 100}%`,
            field: f 
          }
          console.log('f', f)


          headers.push( header )
        })

        headers.push(            {
                text: '',
                value: 'select',
                width: '5px',
                align: 'center',
                sortable: false,
                class: 'select'
            })
        

        console.log('headers', headers)
        return headers
      },

      headerSelectIcon () {
          let oneSelected = false
          let oneUnselected = false
          for (let i=0;i<this.items.length;i++) {
              if (this.items[i].selected) {
                  oneSelected = true
              } else {
                  oneUnselected = true
              }
              if (oneSelected && oneUnselected) {
                  return 'remove_circle_outline'
              }
          }
          return oneSelected ? 'check_circle_outline' : 'radio_button_unchecked'
      },      

    },
    watch: {

    }
  }
</script>

